import jsPDF from "jspdf";
import lillyBelleFont from "../../assets/fonts/lillyBelleFont";

export function exportToPDF(dataToExport) {
	if (!Array.isArray(dataToExport) || dataToExport.length === 0) return;

	const doc = new jsPDF({
		orientation: "portrait",
		unit: "mm",
		format: "a4"
	});
	const pageWidth = doc.internal.pageSize.getWidth();
	const pageHeight = doc.internal.pageSize.getHeight();

	// Registrar a fonte Lilly Belle
	doc.addFileToVFS("LillyBelle.ttf", lillyBelleFont);
	doc.addFont("LillyBelle.ttf", "LillyBelle", "normal");

	dataToExport.forEach((obj, index) => {
		if (index > 0) doc.addPage();

		// ---------- BORDA ----------
		doc.setLineWidth(1);
		doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

		// ---------- TÍTULO ----------
		doc.setFont("LillyBelle", "normal");
		doc.setFontSize(28);
		const title = "Pitaya";
		const titleWidth = doc.getTextWidth(title);
		doc.text(title, pageWidth / 2 - titleWidth / 2, 30);

		// ---------- INFORMAÇÕES ----------
		doc.setFont("helvetica", "bold");
		doc.setFontSize(14);
		const startY = 50;
		const lineHeight = 10;

		doc.text("Nome:", 20, startY);
		doc.text("Telefone:", 20, startY + lineHeight);
		doc.text("E-mail:", 20, startY + lineHeight * 2);

		doc.setFont("helvetica", "normal");
		doc.text(obj.nome, 40, startY);
		doc.text(obj.telefone.replace("+55", ""), 45, startY + lineHeight);
		doc.text(obj.email, 40, startY + lineHeight * 2);
	});

	doc.save("Fichas_Pitaya.pdf");
}
